//@flow

// Vendors
import React from 'react';
import { Switch, Route } from 'react-router-dom';

// Components
import { PrivateRoute } from '../components';

// Pages
import getPages from '../pages';
import PAGE_TYPES from '../pages/pageTypes';

const { OnboardingPage, NoMatchPage } = getPages(PAGE_TYPES.AUTH_BASIC);

const RoutesAuthBasic = () => (
  <div className="basic-private-layout-wrapper">
    <Switch>
      <PrivateRoute path="/getting-started" component={OnboardingPage} />
      <Route component={NoMatchPage} />
    </Switch>
  </div>
);

export default RoutesAuthBasic;
